import React from 'react';

import { SxProps, Theme } from '@mui/material';
import { Link, Typography, TypographyTypeMap } from '@mui/material';
import { InterpolatedLinkCopy } from 'server/config-cache/types';

interface Props {
  copyArray: InterpolatedLinkCopy;
  typographyProps: TypographyTypeMap['props'];
  linkStyles?: SxProps<Theme>;
}

/**
 * Component for rendering copy with interpolated links from config.
 *
 * Developed to solve for the requirements expressed in this ticket: https://territory-foods.atlassian.net/browse/PLAT-839
 * where not only the href & display text of a link itself is configurable per tenant, but the surrounding copy as well.
 *
 * Rather than adding a bunch of specific keys to handle the situation, we can just configure it as an array and allow this component
 * to map over the array entries to handle, so things are a little less verbose.
 */
const InterpolatedLinkTypography: React.FC<Props> = ({
  copyArray,
  typographyProps,
  linkStyles,
}) => {
  return (
    <Typography {...typographyProps}>
      {copyArray.map((entry) => {
        if (typeof entry === 'string') {
          return entry;
        } else {
          return (
            <Link
              key={entry.displayText + entry.url}
              sx={linkStyles}
              href={entry.url}
              target={entry.target}
            >
              {entry.displayText}
            </Link>
          );
        }
      })}
    </Typography>
  );
};

export default InterpolatedLinkTypography;
